import React, { useEffect, useState, useContext } from 'react';

import { getLeaderboard } from './LeaderboardClient';

import TotalDistance from './TotalDistance';
import LeaderboardEntry from './LeaderboardEntry';

import Error from 'Components/Form/Error';

import { CurrentUserContext } from 'Components/Participant/Auth/RequiresCurrentUserContext';

const DEFAULT_NUMBER_TO_SHOW = 10;
const NUMBER_TO_ADD = 20;

const progressPercent = ( total ) =>
{
    return Math.min ( 1, Number ( total ) / Number ( process.env.REACT_APP_DISTANCE_GOAL ) );
}

function Leaderboard () 
{
    const { customAttributes } = useContext ( CurrentUserContext );

    const [ level, setLevel ] = useState ( 1 );
    const [ loadedLevel, setLoadedLevel ] = useState ( null );
    const [ isLoading, setIsLoading ] = useState ( false );
    const [ error, setError ] = useState ( { isError: false, message: null } );
    const [ entries, setEntries ] = useState ( null );
    const [ totalDistance, setTotalDistance ] = useState ( null );
    const [ funds, setFunds ] = useState ( null );
    const [ campaignStatus, setCampaignStatus ] = useState ( null );

    const [ numberToShow, setNumberToShow ] = useState ( DEFAULT_NUMBER_TO_SHOW );

    const [ level1Cache, setLevel1Cache ] = useState ( null );
    const [ level2Cache, setLevel2Cache ] = useState ( null );
    const [ level3Cache, setLevel3Cache ] = useState ( null );

    useEffect ( () => {

        if ( error.isError === false && ( ( isLoading === false && entries === null ) || level !== loadedLevel ) )
        {
            if ( level === 1 && level1Cache !== null )
            {
                setEntries ( level1Cache.entries );
                setTotalDistance ( level1Cache.total );
                setFunds ( level1Cache.funds );
                setLoadedLevel ( 1 );
            }
            else if ( level === 2 && level2Cache !== null )
            {
                setEntries ( level2Cache.entries );
                setTotalDistance ( level2Cache.total );
                setFunds ( level2Cache.funds );
                setLoadedLevel ( 2 );
            }
            else if ( level === 3 && level3Cache !== null )
            {
                setEntries ( level3Cache.entries );
                setTotalDistance ( level3Cache.total );
                setFunds ( level3Cache.funds );
                setLoadedLevel ( 3 );
            }
            else
            {
                setIsLoading ( true );
            
                getLeaderboard ( level )
                    .then ( response => {
                        setEntries ( response.data.entries );
                        setTotalDistance ( response.data.total );
                        setLoadedLevel ( response.data.level );                
                        setFunds ( response.data.funds );
                        setCampaignStatus ( response.data.status );
                        setIsLoading ( false );
                        setError ( { isError: false, message: null } );
                        
                        if ( level === 1 )
                        {
                            setLevel1Cache ( response.data );
                        }
                        else if ( level === 2 )
                        {
                            setLevel2Cache ( response.data );
                        }
                        else if ( level === 3 )
                        {
                            setLevel3Cache ( response.data );
                        }
                    } )
                    .catch ( error => {
                        setEntries ( [] );
                        setTotalDistance ( 0 );
                        setIsLoading ( false );
                        setError ( { isError: true, message: error?.message ? error.message : JSON.stringify ( error ) } )
                    } );
            }
        }

    }, [ level, isLoading, entries, totalDistance ] );

    var myTeam = null;

    if ( customAttributes !== null )
    {
        if ( level === 1 && customAttributes["custom:location"] !== null )
        {
            myTeam = customAttributes["custom:location"];
        }
        else if ( level === 2 && customAttributes["custom:region"] !== null )
        {
            myTeam = customAttributes["custom:region"];
        }
        else if ( level === 3 && customAttributes["custom:team"] !== null )
        {
            myTeam = customAttributes["custom:team"];
        }
    }

    let leaderboardEntries = null;
    
    const greatestDistance = entries?.length > 0 ? entries.reduce ( ( accumulator, entry ) => Math.max ( accumulator, entry.distance ), 0 ) : 0;
    const displayProgressPercent = progressPercent ( totalDistance );

    if ( entries?.length )
    {
        leaderboardEntries = entries.slice ( 0, numberToShow ).map ( ( entry, index ) => <LeaderboardEntry key={entry.name} number={index + 1} name={entry.name} distance={entry.distance} progressPercent={displayProgressPercent} greatestDistance={greatestDistance} isMyTeam={entry.name === myTeam} /> );
    }

    let myTeamEntries = null;
    let myTeamIndex = -1;

    if ( entries?.length )
    {
        myTeamIndex = entries.findIndex ( entry => entry.name  === myTeam );

        if ( myTeamIndex > numberToShow )
        {
            myTeamEntries = entries.slice ( myTeamIndex - 2, myTeamIndex + 3 ).map ( ( entry, index ) => <LeaderboardEntry key={entry.name} number={myTeamIndex - 2 + index + 1} name={entry.name} distance={entry.distance} progressPercent={displayProgressPercent} greatestDistance={greatestDistance} isMyTeam={entry.name === myTeam} /> );
        }
    }

    const common = "hover:bg-pgsurface focus:bg-pgsurface hover:text-pgdarkteal focus:text-pgdarkteal text-xs xs:text-sm";
    const unselectedButtonClass = "rounded-b-none " + common;
    const selectedButtonClass = "bg-pgsurface rounded-b-none " + common;

    let status = null;

    if ( campaignStatus === "NOT_STARTED" )
    {
        status = <div className="bg-pgjoin p-4 mb-4 rounded-2xl">
                     <h2 className="p-0 m-0 text-pgwhite text-sm xs:text-base">The campaign has not yet begun.</h2>
                </div>
    }
    else if ( campaignStatus === "ENDED" )
    {
        status = <div className="bg-pgjoin p-4 mb-4 rounded-2xl">
                    <h2 className="p-0 m-0 text-pgwhite text-sm xs:text-base">The campaign has ended.</h2>
                </div>
    }


    return  <>
                { error.isError && <Error message={error.message} /> }
                { status }
                <TotalDistance distance={totalDistance} funds={funds} />
                <h1 className="text-sm xs:text-base py-1 px-2 xs:py-2 xs:px-4 p-0 m-0 text-3xl text-pgwhite">{level === 1 ? "Location" : ( level === 2 ? "Region/Division" : "Team" ) } leaderboard</h1>
                
                <div className="inline-flex gap-2 justify-start border-bottom">
                    <button onClick={ () => setLevel ( 1 ) } className={ level === 1 ? selectedButtonClass : unselectedButtonClass }>Location</button>
                    <button onClick={ () => setLevel ( 2 ) } className={ level === 2 ? selectedButtonClass : unselectedButtonClass }>Region/Division</button>
                    <button onClick={ () => setLevel ( 3 ) } className={ level === 3 ? selectedButtonClass : unselectedButtonClass }>Team</button>
                </div>
                <div className="bg-pgsurface pt-4">
                    {leaderboardEntries}
                </div>
                
                { entries?.length > numberToShow && <div className="bg-pgsurface p-4 flex flex-row justify-center">
                        <button className="m-0 w-full md:w-4/6" onClick={ () => setNumberToShow ( numberToShow + NUMBER_TO_ADD ) }>Show more</button>
                    </div> }
                    
                
                {myTeamEntries && <div className="text-xl bg-pgsurface mt-8">
                                    <h3 className="px-4 py-4 pb-0 m-0 font-bold text-pgorange">Your team is placed {(myTeamIndex + 1)}</h3>
                                    {myTeamEntries}
                                </div> }
            </>
}

export default Leaderboard;
